import { apiClient } from 'common/clients/api.client';
import { API_ENDPOINTS } from 'common/constants/api-endpoints.constants';
import { EApiPathParams } from 'common/enums/api-path-params.enum';
import {
  TAddRolePermissionReqParams,
  TAddRolePermissionResData,
  TCreateRoleReqParams,
  TCreateRoleResData,
  TCreateScopeReqParams,
  TCreateScopeResData,
  TDeleteRoleReqParams,
  TDeleteRoleResData,
  TPermissionTableResData,
  TRemoveRolePermissionReqParams,
  TRemoveRolePermissionResData,
  TRolesListResData,
  TScopeResData,
} from '../types/roles.types';

export const getPermissionTableService = async (counterpartyGuid: string): Promise<TPermissionTableResData> => {
  const url = API_ENDPOINTS.RBAC.COUNTERPARTY_RBAC_PERMISSION_TABLE
    .replace(EApiPathParams.CounterpartyGuid, counterpartyGuid);
  const res = await apiClient.get<TPermissionTableResData>(url);

  return res.data;
};

export const createRoleService = async (
  counterpartyGuid: string,
  params: TCreateRoleReqParams
): Promise<TCreateRoleResData> => {
  const url = API_ENDPOINTS.RBAC.COUNTERPARTY_RBAC_ROLE.replace(EApiPathParams.CounterpartyGuid, counterpartyGuid);
  const res = await apiClient.post<TCreateRoleResData>(url, params);

  return res.data;
};

export const deleteRoleService = async (
  counterpartyGuid: string,
  params: TDeleteRoleReqParams
): Promise<TDeleteRoleResData> => {
  const url = API_ENDPOINTS.RBAC.COUNTERPARTY_RBAC_ROLE.replace(EApiPathParams.CounterpartyGuid, counterpartyGuid);
  const config = {
    data: params,
  };
  const res = await apiClient.delete<TDeleteRoleResData>(url,config);

  return res.data;
};

export const addPermissionToRoleService = async (
  counterpartyGuid: string,
  params: TAddRolePermissionReqParams
): Promise<TAddRolePermissionResData> => {
  const url = API_ENDPOINTS.RBAC.COUNTERPARTY_RBAC_PERMISSION
    .replace(EApiPathParams.CounterpartyGuid, counterpartyGuid);
  const res = await apiClient.post<TAddRolePermissionResData>(url, params);

  return res.data;
};

export const removePermissionFromRoleService = async (
  counterpartyGuid: string,
  params: TRemoveRolePermissionReqParams
): Promise<TRemoveRolePermissionResData> => {
  const url = API_ENDPOINTS.RBAC.COUNTERPARTY_RBAC_PERMISSION
    .replace(EApiPathParams.CounterpartyGuid, counterpartyGuid);
  const config = {
    data: params,
  };
  const res = await apiClient.delete<TRemoveRolePermissionResData>(url, config);

  return res.data;
};

export const createScopeService = async (
  counterpartyGuid: string,
  params: TCreateScopeReqParams
): Promise<TCreateScopeResData> => {
  const url = API_ENDPOINTS.RBAC.COUNTERPARTY_RBAC_SCOPE
    .replace(EApiPathParams.CounterpartyGuid, counterpartyGuid);
  const res = await apiClient.post<TCreateScopeResData>(url, params);

  return res.data;
};

export const getScopeListService = async (counterpartyGuid: string): Promise<TScopeResData> => {
  const url = API_ENDPOINTS.RBAC.COUNTERPARTY_RBAC_SCOPE_LIST
    .replace(EApiPathParams.CounterpartyGuid, counterpartyGuid);
  const res = await apiClient.get<TScopeResData>(url);

  return res.data;
};

export const getCounterpartyRoleListService = async (
  counterpartyGUID: string
): Promise<TRolesListResData> => {
  const url = API_ENDPOINTS.RBAC.COUNTERPARTY_RBAC_ROLE.replace(EApiPathParams.CounterpartyGuid, counterpartyGUID);
  const res = await apiClient.get<TRolesListResData>(url);

  return res.data;
};
